import React from 'react';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Image from "./Image";
import Header from "./Header";
import {withStyles} from "@material-ui/core";

const styles = theme => ({
    appBar: {
        height: 65
    }
});

function TopBar({classes, headerTitle, logout, email}) {
    return (
        <AppBar position="fixed" color="primary" className={classes.appBar}>
            <Toolbar className="toolbar">
                <Image className="brand-logo"
                       name="Revevol Group"
                       src="images/veolia-logo.png"/>

                <Header header={headerTitle}/>

                <div className="bar-info-right">
                    {email && <span>{email}</span>}
                    {logout && <span className="logout" onClick={logout}>Logout</span>}
                </div>

            </Toolbar>
        </AppBar>
    );
}

export default withStyles(styles)(TopBar);